// Third Party Imports
import React from 'react';
import {forOwn, sortBy, toArray} from 'lodash';
import PropTypes from 'prop-types';

import {FormInput} from '@homeaway/react-form-components';
import FormSelect from '@homeaway/react-form-select';
import StabAddressFormConfigurator from '@homeaway/stab-address-form-configurator';

class Address extends React.Component {
    constructor(props) {
        super(props);
    }

    getStateOptions(regions) {
        const stateOptionList = toArray(regions).map((entry) => {
            return {
                value: entry,
                label: entry
            };
        });

        return [{value: '', label: ''}].concat(stateOptionList);
    }

    getFormFields = (country) => {
        const {translations, addressType} = this.props;
        const addressForm = StabAddressFormConfigurator.getConfigByCountry(
            country
        );
        const regions = StabAddressFormConfigurator.getRegions(country);
        const stateOptions = regions ? this.getStateOptions(regions) : null;

        let formFields = [];
        forOwn(addressForm, (formPart, key) => {
            const label = formPart.label;
            const translatedLabel = translations[
                `ipmob.address.${label}.${country}`
            ]
                ? translations[`ipmob.address.${label}.${country}`]
                : translations[`ipmob.address.${label}`];

            formFields.push({
                ...formPart,
                fieldId: addressType ? `${addressType}_${key}` : key,
                label: translatedLabel
            });
        });
        formFields = sortBy(formFields, 'posIndex');
        return {
            formFields,
            stateOptions
        };
    };

    renderAddressForm = () => {
        const addressFields = [];
        let formInput;
        const {country, addressType} = this.props;
        const {formFields, stateOptions} = country
            ? this.getFormFields(country)
            : {};
        let {
            handleAddressFields,
            addressFormValues,
            addressFormErrors,
            handleFieldsOnBlur,
            handleFieldsOnFocus,
            extendedStyle
        } = this.props;
        extendedStyle = extendedStyle || '';
        formFields.map((entry) => {
            const fieldValue = addressFormValues[entry.fieldId] || '';
            const fieldErrorValue = addressFormErrors[entry.fieldId] || '';

            const stateProvinceFieldId = addressType ? `${addressType}_stateProvince` : 'stateProvince';
            if (entry.fieldId === stateProvinceFieldId && stateOptions) {
                formInput = (
                    <div key={entry.fieldId} className="wrapper">
                        <div className={`content-col${extendedStyle}`}>
                            <FormSelect
                                id={entry.fieldId}
                                name={entry.fieldId}
                                items={stateOptions}
                                label={entry.label}
                                value={fieldValue}
                                onChange={handleAddressFields}
                                errorMsg={fieldErrorValue}
                                onBlur={handleFieldsOnBlur}
                            />
                        </div>
                    </div>
                );
            } else {
                formInput = (
                    <div key={entry.fieldId} className="wrapper">
                        <div className={`content-col${extendedStyle}`}>
                            <FormInput
                                type="text"
                                id={entry.fieldId}
                                name={entry.fieldId}
                                label={entry.label}
                                value={fieldValue}
                                onChange={handleAddressFields}
                                errorMsg={fieldErrorValue}
                                onBlur={handleFieldsOnBlur}
                                onFocus={handleFieldsOnFocus}
                            />
                        </div>
                    </div>
                );
            }
            addressFields.push(formInput);
        });

        return addressFields;
    };

    render() {
        let {
            translations,
            countryList,
            handleAddressFields,
            country,
            addressFormErrors,
            handleFieldsOnBlur,
            extendedStyle,
            addressType
        } = this.props;
        extendedStyle = extendedStyle || '';
        const fieldId = addressType ? `${addressType}_country` : 'country';

        return (
            <div>
                <div className="wrapper">
                    <div className={`content-col${extendedStyle}`}>
                        <FormSelect
                            id={fieldId}
                            name={fieldId}
                            items={countryList}
                            label={translations['ipmob.address.label_1']}
                            value={country}
                            onChange={handleAddressFields}
                            errorMsg={addressFormErrors[fieldId]}
                            onBlur={handleFieldsOnBlur}
                        />
                    </div>
                </div>
                {country ? this.renderAddressForm() : null}
            </div>
        );
    }
}

Address.propTypes = {
    translations: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    addressFormValues: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    addressFormErrors: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    countryList: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    country: PropTypes.string,
    handleFieldsOnBlur: PropTypes.func,
    handleAddressFields: PropTypes.func,
    setAddressFormLabels: PropTypes.func
};

Address.defaultProps = {
    country: 'US',
    addressFormValues: {},
    addressFormErrors: {}
};

export default Address;
